module.exports = __webpack_public_path__ + "static/media/exchangeMIT.431ba0bc.jpg";